import { createSelector } from 'reselect';
import { plpoExperienceSliceName } from '../reducers/PLPOExperience';
import { isRequestFulfilled } from '../interface';
export const selectPLPOExperienceState = ({
  [plpoExperienceSliceName]: plpoExperienceState
}) => plpoExperienceState;
export const selectPLPOGroupKey = createSelector(selectPLPOExperienceState, plpoExperienceState => plpoExperienceState.groupKey);
export const selectPLPOEligibility = createSelector(selectPLPOExperienceState, plpoExperienceState => plpoExperienceState.isEligible);
export const selectPLPOProgress = createSelector(selectPLPOExperienceState, plpoExperienceState => plpoExperienceState.progress);
export const selectIsFetchingPLPOExperience = createSelector(selectPLPOExperienceState, ({
  status
}) => status && !isRequestFulfilled(status));
export const selectHasPLPOError = createSelector(selectPLPOExperienceState, plpoExperienceState => plpoExperienceState.hasError);